import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  // Servicio o componente
transformOutlookEvents(outlookEvents: any): any[] {
  // El array viene en outlookEvents.data
  const eventsArray = outlookEvents?.data || [];
  
  if (!Array.isArray(eventsArray)) {
    console.error('Los eventos no son un array:', eventsArray);
    return [];
  }
  
  return eventsArray.map(event => {
    const startDate = this.parseOutlookDate(event.start);
    const endDate = this.parseOutlookDate(event.end);
    const color = this.getEventColor(event);
    
    return {
      title: event.subject,
      start: startDate,
      end: endDate,
      backgroundColor: color,
      borderColor: color,
      extendedProps: {
        attendees: event.attendees,
        joinUrl: event.joinUrl,
        isOnlineMeeting: !!event.joinUrl
      }
    };
  });
}

// Parsear fecha de formato "DD-MM-YYYY HH:mm" a ISO "YYYY-MM-DDTHH:mm:ss"
parseOutlookDate(dateString: string): string {
  // "10-10-2025 18:30" -> "2025-10-10T18:30:00"
  const [datePart, timePart] = dateString.split(' ');
  const [day, month, year] = datePart.split('-');
  return `${year}-${month}-${day}T${timePart}:00`;
}

// Asignar colores (puedes personalizar la lógica)
getEventColor(event: any): string {
  // Si está cancelado
  if (event.subject.toLowerCase().includes('cancelado')) {
    return '#999999';
  }
  
  // Si es reunión online
  if (event.joinUrl) {
    return '#ff8c42';
  }
  
  // Color por defecto
  return '#ff6b35';
}
  
}
